var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.form)?_c('rkm-area',{attrs:{"subtitle":_vm.subtitle,"title":_vm.title}},[_c('Form',{attrs:{"data":_vm.data,"funcionalidade":_vm.funcionalidade}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }